import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getCount = (expired) => {
  const queryString = qs.stringify({ expired });
  return axios.get(
    `/api/dps/count?${queryString}`
  );
};

export const useCount = (expired = false, options = {}) => {
  return useQuery(
    `dps-expired-${expired}-count`,
    () => getCount(expired),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}